import { ISoilTypeService, SoilCategory, SoilTypeId, SubsoilTypeId } from "../omnia";

export class SoilTypeService implements ISoilTypeService {

    private cls: { [key: string]: SoilCategory }

    constructor() {

        this.setup();

    }

    private setup() {

        var cls: any = {};

        cls["1/1"] = 2;
        cls["1/2"] = 2;
        cls["1/3"] = 2;
        cls["1/4"] = 2;
        cls["1/5"] = 2;
        cls["1/6"] = 2;
        cls["1/7"] = 3;
        cls["1/8"] = 3;
        cls["2/1"] = 2;
        cls["2/2"] = 2;
        cls["2/3"] = 2;
        cls["2/4"] = 2;
        cls["2/5"] = 2;
        cls["2/6"] = 2;
        cls["2/7"] = 4;
        cls["2/8"] = 3;
        cls["3/1"] = 2;
        cls["3/2"] = 2;
        cls["3/3"] = 2;
        cls["3/4"] = 2;
        cls["3/5"] = 2;
        cls["3/6"] = 2;
        cls["3/7"] = 4;
        cls["3/8"] = 3;
        cls["4/1"] = 4;
        cls["4/2"] = 4;
        cls["4/3"] = 4;
        cls["4/4"] = 4;
        cls["4/5"] = 4;
        cls["4/6"] = 4;
        cls["4/7"] = 4;
        cls["4/8"] = 4;
        cls["5/1"] = 4;
        cls["5/2"] = 4;
        cls["5/3"] = 4;
        cls["5/4"] = 4;
        cls["5/5"] = 4;
        cls["5/6"] = 4;
        cls["5/7"] = 4;
        cls["5/8"] = 4;
        cls["6/1"] = 2;
        cls["6/2"] = 2;
        cls["6/3"] = 2;
        cls["6/4"] = 2;
        cls["6/5"] = 2;
        cls["6/6"] = 2;
        cls["6/7"] = 2;
        cls["6/8"] = 3;
        cls["7/1"] = 2;
        cls["7/2"] = 2;
        cls["7/3"] = 2;
        cls["7/4"] = 2;
        cls["7/5"] = 2;
        cls["7/6"] = 2;
        cls["7/7"] = 2;
        cls["7/8"] = 3;
        cls["8/1"] = 2;
        cls["8/2"] = 2;
        cls["8/3"] = 2;
        cls["8/4"] = 2;
        cls["8/5"] = 2;
        cls["8/6"] = 2;
        cls["8/7"] = 2;
        cls["8/8"] = 3;
        cls["9/1"] = 1;
        cls["9/2"] = 1;
        cls["9/3"] = 1;
        cls["9/4"] = 1;
        cls["9/5"] = 1;
        cls["9/6"] = 1;
        cls["9/7"] = 1;
        cls["9/8"] = 2;
        cls["10/1"] = 1;
        cls["10/2"] = 1;
        cls["10/3"] = 1;
        cls["10/4"] = 1;
        cls["10/5"] = 1;
        cls["10/6"] = 1;
        cls["10/7"] = 1;
        cls["10/8"] = 1;
        cls["11/1"] = 1;
        cls["11/2"] = 1;
        cls["11/3"] = 1;
        cls["11/4"] = 1;
        cls["11/5"] = 1;
        cls["11/6"] = 1;
        cls["11/7"] = 1;
        cls["11/8"] = 1;
        cls["12/1"] = 5;
        cls["12/2"] = 5;
        cls["12/3"] = 5;
        cls["12/4"] = 5;
        cls["12/5"] = 5;
        cls["12/6"] = 5;
        cls["12/7"] = 5;
        cls["12/8"] = 5;
        cls["13/1"] = 6;
        cls["13/2"] = 6;
        cls["13/3"] = 6;
        cls["13/4"] = 6;
        cls["13/5"] = 6;
        cls["13/6"] = 6;
        cls["13/7"] = 6;
        cls["13/8"] = 6;

        this.cls = cls;

    }

    getSoilClassification(soilTypeId: SoilTypeId, subsoilTypeId: SubsoilTypeId): SoilCategory {

        var key = soilTypeId + "/" + subsoilTypeId;

        return this.cls[key];

    }

}

